module.exports = __webpack_public_path__ + "static/media/momentumclone.ffa33a98.JPG";